import { render, staticRenderFns } from "./SmallModal.vue?vue&type=template&id=12dd39bf&"
import script from "./SmallModal.vue?vue&type=script&lang=js&"
export * from "./SmallModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports